import React from 'react';

const Index = () => {
    return (
        <div className='w-full h-screen z-50 flex justify-center items-center'>
            <img className='w-28' src={process.env.PUBLIC_URL + '/images/odu.png'} alt='' />
        </div>
    );
}

export default Index;
